module.exports = __webpack_public_path__ + "media/luxury-2026/classic-breakfast-41cd33f1.jpg";